import { DEL, GET, POST } from "./index";

export function fetchData() {
  return GET("/api-keys");
}

export function createData(body) {
  return POST("/api-keys", body);
}

export function revokeData(id) {
  return DEL(`/api-keys/${id}`);
}
